module.exports = function getResource(label) {
    let resources = {
        emailLabel: 'Email address',
        nameLabel: 'Name',
        editLink: 'Edit'
    };

    return resources[label];
};
